module.exports = __webpack_public_path__ + "mainassets/img/anim_02_570x570.81ee8ffc.webp";